import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/article`, {params})
    },
    create(params) {
        return Vue.axios.post(`/article/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/article/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/article/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/article/${id}`)
    },
}
